var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0076 19.7714V16.7047C8.00758 15.9246 8.67697 15.2908 9.50633 15.2856H12.5443C13.3776 15.2856 14.0532 15.9209 14.0532 16.7047V16.7047V19.7809C14.053 20.4432 14.615 20.9845 15.319 21H17.3443C19.3633 21 21 19.4607 21 17.5618V17.5618V8.83784C20.9892 8.09083 20.6163 7.38935 19.9873 6.93303L13.0608 1.6853C11.8473 0.771566 10.1223 0.771566 8.90886 1.6853L2.01266 6.94256C1.38132 7.39702 1.00778 8.09967 1 8.84736V17.5618C1 19.4607 2.63671 21 4.6557 21H6.68101C7.40248 21 7.98734 20.4499 7.98734 19.7714V19.7714",
    stroke: "#404040",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome2);
export default __webpack_public_path__ + "static/media/home2.2b4847be593e85bc4ba6a885bc764fe8.svg";
export { ForwardRef as ReactComponent };